import { defineStore } from 'pinia';
import { ref } from 'vue';

import { xhr } from '@/helpers/service.ts';

import { useCompetitionStore } from './useCompetitionStore';
import { useResultsStore } from './useResultsStore';

export const useGraphStore = defineStore('graph', () => {
  const resultStore = useResultsStore();
  const competitionStore = useCompetitionStore();

  const currentGraph = ref();
  const graphs = ref<Record<string, unknown>>({});

  async function getGraph(id: string) {
    const result = resultStore.results.find(({ _id }) => _id === id);

    if (result) {
      const distance = competitionStore.currentCompetition?.distance;
      const { personId: competitorId, classId } = result;
      const endpoint = `/${competitorId}/${classId}/${distance}`;

      if (graphs.value[endpoint]) {
        return graphs.value[endpoint];
      }

      const history = await xhr(`/results/history/${competitorId}/${classId}/${distance}`);

      graphs.value[endpoint] = history;

      return history;
    }
  }

  return {
    graphs,
    currentGraph,
    getGraph,
  };
});
